import {
  AUTHORISED_DISTRIBUTORS,
  PARALLEL_IMPORTERS,
} from '@/constants/global';

import type { DealerType } from './types';

export const isTab = (
  value: unknown,
): value is DealerType => (
  typeof value === 'string'
  && [AUTHORISED_DISTRIBUTORS, PARALLEL_IMPORTERS].includes(value)
);
